// import the react components
import React from "react";
import { Link } from "react-router-dom";
import useNavigation from "./../context/navigation";
import useAuth from "./../context/auth";
import Alerter from "./../components/alerter";
import OuterHeader from "./../ui/outer-header";
import { gradient_primary } from "./../assets/data/colors";

// the home of the website
const Home = () => {
    const { auth } = useAuth();
    useNavigation();

    return (
        <div>
            <Alerter />
            {!auth && <OuterHeader />}

            <div>
                <section className="dark:bg-main-dark-bg mt-5 min-h-[500px] h-[calc(100vh-150px)] flex justify-center items-center">
                    <div className="py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6">
                        <div className="mx-auto max-w-screen-md text-center">
                            <h1 className="home-header mb-4 text-3xl sm:text-5xl lg:text-6xl tracking-tight font-extrabold leading-tight text-gray-900 dark:text-white capitalize">manage your clinic wisely</h1>
                            <p className="mb-8 font-light text-gray-700 dark:text-gray-400 text-base md:text-lg px-2"><strong className="dark:text-gray-200">All-in-one:</strong> Effortlessly manage your schedule and patient records, monitor clinic performance, connect and learn with other dentists, and order products.</p>
                            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 w-full">
                                <Link to="/logup" className="text-white transition-opacity duration-100 hover:opacity-90 focus:ring-0 rounded-full px-5 py-3 sm:px-8 sm:py-3 text-lg sm:text-lg mr-2 focus:outline-none dark:focus:ring-0" style={{background: gradient_primary}}>Get started</Link>
                                <Link to="/about" className="focus:ring-0 rounded-md text-lg focus:outline-none dark:focus:ring-0 dark:text-gray-200 hover:opacity-80">Learn more</Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};
export default Home;